import { createContext, useState } from 'react';
import useVisible from '../use-visible';

const UpgradeContext = createContext({
  visible: false
});

function useUpgradeContext() {
  const { visible, onClose, onOpen } = useVisible();
  const { visible: permVisible, onClose: onPermClose, onOpen: onPermOpen } = useVisible();
  const [currentPackageKey, setCurrentPackageKey] = useState('');
  return {
    visible,
    onClose,
    onOpen,
    currentPackageKey,
    setCurrentPackageKey,
    permVisible,
    onPermClose,
    onPermOpen
  };
}

useUpgradeContext.UpgradeContext = UpgradeContext;

export default useUpgradeContext;
